import React from 'react';
import styles from './Chip.module.css';

/** Small rounded metadata pill: short label + optional leading icon. */
const Chip = React.forwardRef(
  (
    {
      children,
      tone = 'default',
      size = 'md',
      icon,
      className,
      as: Tag = 'span',
      ...rest
    },
    ref
  ) => {
    const classes = [
      styles.chip,
      styles[`tone-${tone}`],
      styles[`size-${size}`],
      className,
    ]
      .filter(Boolean)
      .join(' ');
    return (
      <Tag ref={ref} className={classes} {...rest}>
        {icon && <span className={styles.icon}>{icon}</span>}
        {children}
      </Tag>
    );
  }
);

Chip.displayName = 'Chip';
export default Chip;
